<template>
  <div class="col-lg-10 col-md-11 col-sm-12 m-auto">
    <div id="serviceNotice">
      <h5 class="pl-15 pt-20">
        <i class="fas fa-exclamation-circle"></i>
        서비스 이용안내
      </h5>
      <ul class="fa-ul pb-20 pr-10 ft-1" id="serviceInfo">
        <li>
          <span class="fa-li"> <i class="fas fa-caret-right"></i> </span
          >공인중개사법에 따라, 건축물대장상 소유자만 방내놓기(임대 의뢰)
          서비스를 이용하실 수 있습니다.
        </li>
        <!-- <li>
          <span class="fa-li"> <i class="fas fa-caret-right"></i> </span
          >공인중개사법에 따라, 건축물대장상 소유자만 방내놓기(임대 의뢰)
          서비스를 이용하실 수 있습니다.(소유자 인증 후 서비스 이용 가능)
        </li> -->
        <li>
          <span class="fa-li"> <i class="fas fa-caret-right"></i> </span>소유자
          인증, 매물 주소 확인 절차를 거친 후 전속중개계약서를 체결하실 수
          있습니다.
        </li>
        <li>
          <span class="fa-li"> <i class="fas fa-caret-right"></i> </span
          >집비오는 부동산의 허위매물을 완전 차단하기 위하여, 한 명의
          공인중개사에게만 의뢰하는 전속중개계약만을 체결합니다. (타
          공인중개사에게 의뢰하신 경우, 서비스를 이용하실 수 없습니다.)
        </li>
        <li>
          <span class="fa-li"> <i class="fas fa-caret-right"></i> </span>매물
          주소를 입력하시면, 건축물대장에 있는 정보가 자동으로
          불러와집니다.(건축물대장상에 없는 내용은 직접 입력하실 수 있습니다.)
        </li>
        <li>
          <span class="fa-li"> <i class="fas fa-caret-right"></i> </span
          >의뢰하신 매물은 집비오의 검수 과정을 거쳐 노출됩니다.(의뢰 -> 검토 ->
          사진 촬영 서비스 진행 -> 수정 및 확인 ->최종 노출)
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {};
</script>
<style>
/*div {
  font-size: 18px;
}*/
#serviceNotice {
  background-color: #c3d1fd30;
  margin-top: 2%;
  margin-bottom: 1%;
}

#serviceNotice h5 {
  color: #797979;
}

#serviceInfo li {
  list-style: none;
  color: #797979;
}
</style>
